import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, resolveDirective as _resolveDirective, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["type", "disabled", "id", "value"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: ""
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"15px !important","margin-left":"0.5px !important"},
  class: "material-icons-outlined"
}, "close", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "add_circle_outline", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiIcon = _resolveComponent("MultiIcon")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex p-1", { 'flex-wrap': _ctx.wrap }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'chipset-' + _ctx.id + '-option-' + index
      }, [
        _createVNode(_component_Tooltip, {
          textValue: option.description,
          noArrow: true,
          placement: 'bottom'
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["font-normal transition-colors duration-75 ease-linear chip", {
						'chip-sm': _ctx.compact,
						'chip-primary': _ctx.modelValue.includes(option.value),
						'border-0 bg-light': _ctx.filled && !_ctx.modelValue.includes(option.value),
						'opacity-50 bg-gray-50': option.disabled,
						'hover:bg-gray-200': !option.disabled && !_ctx.deletable,
					}])
            }, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.allowMultiple ? 'checkbox' : 'radio',
                class: "w-0 h-0 opacity-0",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.proxyModelValue) = $event)),
                disabled: option.disabled,
                id: 'chipset-' + _ctx.id + '-option-' + index,
                value: option.value
              }, null, 8, _hoisted_1), [
                [_vModelDynamic, _ctx.proxyModelValue]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass([{ 'cursor-pointer': !option.disabled && !_ctx.deletable }, "flex items-center"]),
                for: 'chipset-' + _ctx.id + '-option-' + index
              }, [
                (option.icons)
                  ? (_openBlock(), _createBlock(_component_MultiIcon, {
                      key: 0,
                      class: _normalizeClass(["w-6 -ml-1", [_ctx.compact ? 'mr-1' : 'mr-2']]),
                      icons: option.icons,
                      small: _ctx.compact
                    }, null, 8, ["class", "icons", "small"]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", {
                  innerHTML: option.content
                }, null, 8, _hoisted_3),
                (_ctx.$slots.default)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "default", {
                        optionValue: option.value
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.deletable && !_ctx.disabled)
                  ? (_openBlock(), _createBlock(_component_Btn, {
                      key: 2,
                      onClick: ($event: any) => (_ctx.onRemove(option.value)),
                      class: "z-10 ml-1.5 -mr-1.5 bg-gray-200",
                      size: 'xs',
                      variant: 'icon',
                      outline: true
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_2)
            ], 2)), [
              [_directive_wave, !option.disabled && !_ctx.deletable]
            ])
          ]),
          _: 2
        }, 1032, ["textValue"])
      ]))
    }), 128)),
    (_ctx.showAddChip && !_ctx.disabled)
      ? (_openBlock(), _createBlock(_component_Btn, {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('addChip'))),
          variant: 'icon',
          outline: true,
          class: "-mt-1 -ml-0.5",
          tooltip: _ctx.addChipTooltip
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["tooltip"]))
      : _createCommentVNode("", true)
  ], 2))
}